import { useEffect } from 'react'
import type { QuickAction } from '@/features/chat/hooks/useChat.types'

/** Window event name modules/ surfaces dispatch to push follow-up chips into the chat. */
export const CHAT_QUICK_ACTIONS_EVENT = 'xavior:chat-quick-actions'

/**
 * Bridge cross-module follow-up chips into the chat (#2014). Surfaces outside
 * `features/chat` (e.g. the Tasks import modal in `modules/tasks`) cannot call
 * useChat's `addQuickActions` directly — a `modules/` file can't import a
 * `features/chat` hook. So they dispatch a `xavior:chat-quick-actions` window
 * event carrying `{ actions: QuickAction[] }`; ChatBox mounts this hook to listen
 * and forward. Same boundary seam the contacts duplicate-merge surface uses
 * (`xavior:contacts-duplicates-open`). The window event is the contract — keep
 * `CHAT_QUICK_ACTIONS_EVENT` and the `{ actions }` detail shape in sync with the
 * dispatchers.
 */
export function useCrossModuleQuickActions(
  addQuickActions: (actions: QuickAction[]) => void,
): void {
  useEffect(() => {
    const handler = (e: Event) => {
      const actions = (e as CustomEvent).detail?.actions
      if (Array.isArray(actions) && actions.length > 0) addQuickActions(actions)
    }
    window.addEventListener(CHAT_QUICK_ACTIONS_EVENT, handler)
    return () => window.removeEventListener(CHAT_QUICK_ACTIONS_EVENT, handler)
  }, [addQuickActions])
}
